import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import { OverflowHelper } from '../../../helpers';

@Component({
  selector: 'onyx-information-row',
  imports: [OnyxTooltipDirective, TranslatePipe],
  templateUrl: './onyx-information-row.component.html',
  styleUrl: './onyx-information-row.component.scss',
  host: {
    '[class]': `color() + ' size-' + size()`,
    '[class.pointer]': `isPointer()`,
  },
})
export class OnyxInformationRowComponent {
  protected readonly overflowHelper = inject(OverflowHelper);

  public readonly color = input<'gray' | 'blue' | 'green' | 'red' | 'yellow'>(
    'gray',
  );
  public readonly label = input.required<string>();
  public readonly size = input<120 | 184>(184);
  public readonly isPointer = input(false);
}
